import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default defineNuxtPlugin((nuxtApp) => {
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
    gestureDirection: 'vertical',
    smooth: true,
    smoothTouch: false,
    touchMultiplier: 2,
  });

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  lenis.on('scroll', () => {
    ScrollTrigger.update();
  });

  // One Lenis instance serves every page, and it keeps its own scroll position
  // and writes it to the window on every frame. Left alone across a navigation
  // it carries whatever it was still easing toward into the next page: click a
  // link mid-fling and the momentum lands on the page you just opened, which
  // measured as arriving at the very bottom of /projects instead of the top.
  //
  // reset() is the cancel: it snaps the animation to the real scroll position,
  // drops the velocity to zero and stops the tween.
  //
  // Both sides of the navigation, because one alone is not enough. On the way
  // out it kills the fling before it can cross over. On the way in the position
  // has only just been set, and without a second reset Lenis would still hold
  // the outgoing page's offset and put it straight back.
  const router = useRouter();

  router.beforeEach(() => {
    lenis.reset();
  });

  router.afterEach(() => {
    // Two frames on: the incoming page has rendered and the router has applied
    // its scroll position, so there is a real height to measure and a real
    // offset to adopt. Resetting any earlier adopts the outgoing page's.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        lenis.resize();
        lenis.reset();
      });
    });
  });

  nuxtApp.provide('lenis', lenis);
});
